export class GetDoorToDoorReportsRequest {
  public cmd: string = "get_door_to_door_reports";
  constructor(public majlis) { }
}
